import React, { useEffect, useState } from 'react'
import { Container } from 'react-bootstrap';
import { useSelector } from 'react-redux';

const Cart = () => {
    const [record, setrecord] = useState(null);
    var data = useSelector((e) => e.cart.cartdata)



    useEffect(() => {

        setrecord(data)

    }, [])

    return (
        <>

            <Container>
            {
                record && record.map((v, i) => {
                    return (
                        <div key={i} className='d-flex cart box'>
                            <div>
                                <img src={v.thumbnail} al t="" />
                            </div>
                            <div>
                                <span className='name fs-5 fw-bold title'>{v.title}</span><br />
                                <span>category={v.category}</span><br />
                                <span>price={v.price}</span><br />
                                <span>rating={v.rating}</span>
                            </div>
                        </div>
                    )
                })
            }
            </Container>

        </>
    )
}

export default Cart